import React from 'react';
import { formatMonthDisplay } from '../../../utils/dateUtils';

const MonthNavigation = ({ months, selectedMonth, onMonthSelect }) => {
  if (!months || months.length === 0) {
    return null;
  }

  return (
    <div style={{
      marginBottom: '2rem',
      padding: '1.5rem',
      backgroundColor: '#f7fafc',
      borderRadius: '12px',
      border: '1px solid #e2e8f0'
    }}>
      <div style={{
        fontSize: '0.875rem',
        fontWeight: '600',
        color: '#4a5568',
        marginBottom: '1rem',
        fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
        textTransform: 'uppercase',
        letterSpacing: '0.05em'
      }}>
        Filter by Month
      </div>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.75rem'
      }}>
        <button
          onClick={() => onMonthSelect(null)}
          style={{
            padding: '0.5rem 1rem',
            borderRadius: '8px',
            border: selectedMonth === null ? '2px solid #667eea' : '1px solid #e2e8f0',
            backgroundColor: selectedMonth === null ? '#667eea' : 'white',
            color: selectedMonth === null ? 'white' : '#4a5568',
            fontSize: '0.875rem',
            fontWeight: '500',
            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => {
            if (selectedMonth !== null) {
              e.target.style.borderColor = '#667eea';
              e.target.style.color = '#667eea';
            }
          }}
          onMouseOut={(e) => {
            if (selectedMonth !== null) {
              e.target.style.borderColor = '#e2e8f0';
              e.target.style.color = '#4a5568';
            }
          }}
        >
          All Posts
        </button>
        {months.map((month) => (
          <button
            key={month}
            onClick={() => onMonthSelect(month)}
            style={{
              padding: '0.5rem 1rem',
              borderRadius: '8px',
              border: selectedMonth === month ? '2px solid #667eea' : '1px solid #e2e8f0',
              backgroundColor: selectedMonth === month ? '#667eea' : 'white',
              color: selectedMonth === month ? 'white' : '#4a5568',
              fontSize: '0.875rem',
              fontWeight: '500',
              fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => {
              if (selectedMonth !== month) {
                e.target.style.borderColor = '#667eea';
                e.target.style.color = '#667eea';
              }
            }}
            onMouseOut={(e) => {
              if (selectedMonth !== month) {
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.color = '#4a5568';
              }
            }}
          >
            {formatMonthDisplay(month)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MonthNavigation;

